import { useState, useCallback } from 'react';
import { message } from 'antd';
import { pwd307Api, QueryParams, PurchaseRow, UnitSummary } from '../../../services/pwd307Api';

export function usePWD307Query() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<PurchaseRow[]>([]);
  const [unitSummary, setUnitSummary] = useState<UnitSummary[]>([]);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);

  const runQuery = useCallback(async (params: QueryParams) => {
    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp = await pwd307Api.query(params);
      if (resp.data && resp.data.length > 0) {
        setData(resp.data);
        setUnitSummary(resp.unit_summary || []);
        setNoData(false);
      } else {
        setData([]);
        setUnitSummary([]);
        setNoData(true);
        message.info(resp.message || '查無此資料!');
      }
      setQueried(true);
    } catch {
      message.error('查詢失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setData([]);
    setUnitSummary([]);
    setQueried(false);
    setNoData(false);
  }, []);

  return { loading, data, unitSummary, queried, noData, runQuery, reset };
}
